import React from "react";
import Layout from "../Layout";
import {
  Grid,
  makeStyles,
  Typography,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Tooltip,
  withStyles,
} from "@material-ui/core";
import {
  Edit,
  Delete,
  Link,
} from '@material-ui/icons/';
import { withRouter } from "react-router";
import useApi from "Hooks/Admin/useApi";
import useAuth from "Hooks/Admin/useAuth";
import MuiAlert from "@material-ui/lab/Alert";

import "dayjs/locale/ja";
import dayjs from "dayjs";
dayjs.locale("ja");

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    // overflow: "auto",
    flexDirection: "column",
  },
  wrapper: {
    marginTop: theme.spacing(2),
  },
  datepicker: {
    display: "flex",
    alignItems: "baseline",
  },
  table: {
    // width: "1600px",
    overflowX: "auto",
  },
  nthOfTypeOddRow: {
    backgroundColor: "#eee",
  },
  alert: {
    marginTop: theme.spacing(2),
  },
  dateCol: {
    width: "170px",
  },
  signCol: {
    width: "48px",
  },
  linkCol: {
    width: "48px",
    padding: "0px",
  },
  buttonCol: {
    textAlign: "center",
    width: "128px",
  },
  buttonRed: {
    color: "rgb(220, 0, 78)",
    "&:hover": {
      backgroundColor: "rgba(220, 0, 78, 0.04)",
    },
  },
  htmlToolTip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
  subtitle: {
    marginLeft: "5px",
  },
}));

function Information(props) {
  const { request } = useApi();
  const auth = useAuth();
  const classes = useStyles();

  const [informations, setInformations] = React.useState([]);
  const [isShowModal, setIsShowModal] = React.useState(false);
  const [deleteId, setDeleteId] = React.useState(null);
  const [success, setSuccess] = React.useState(false);
  const [successMessage, setSuccessMessage] = React.useState(null);

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Admin - お知らせ管理";

    if (props.location.search.indexOf("create") > -1) {
      setSuccess(true);
      setSuccessMessage("登録が完了しました");
    }
    if (props.location.search.indexOf("edit") > -1) {
      setSuccess(true);
      setSuccessMessage("更新が完了しました");
    }
    if (props.location.search.indexOf("delete") > -1) {
      setSuccess(true);
      setSuccessMessage("削除が完了しました");
    }
  }, []);

  React.useEffect(() => {
    if (!auth.state.token) {
      return;
    }
    fetchInformations();
  }, [auth.state.token]);

  const fetchInformations = () => {
    request({
      method: "GET",
      url: `admin/information`,
    }).then((result) => {
      setInformations(result.data.data);
    });
  };

  const onClickEditButton = (id) => {
    props.history.push(`/admin/information/edit/${id}`);
  };

  const openDialog = (id, date) => {
    setDeleteId(id);
    setIsShowModal(true);
  };

  const deleteInformation = () => {
    request({
      method: "DELETE",
      url: `admin/information/${deleteId}`,
    }).then(() => {
      fetchInformations();
      setIsShowModal(false);
    });
  };

  const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
    },
  }))(Tooltip);

  // お知らせが掲載期間内かどうか（期間内 = true）
  const withinThisPeriodOrNot = (validFrom, validUntil) => {
    // 掲載開始日時がなかったら今は期間外
    if (!validFrom) {return false;}
    // 掲載開始日時が正しくなかったら今は期間外
    if (!dayjs(validFrom).isValid()) {return false;}
    // 現在日時取得
    const nowDate = dayjs();
    // 掲載開始日時が未来だったら今は期間外
    if (dayjs(validFrom).isAfter(nowDate)) {return false;}
    // 掲載終了日時は設定がない場合もある（ずっと掲載しっぱなしにしたいとき）
    if (validUntil && dayjs(validUntil).isValid()) {
      // 掲載終了日時が過去だったら今は期間外
      if (dayjs(validUntil).isBefore(nowDate)) {return false;}
    }
    // 以上に当てはまらなかったら掲載期間内
    return true;
  };

  function Row(props) {
    const { row, index } = props;
    const isNthOfTypeOdd = index % 2 === 0 ? false : true ;
    const isInPeriod = withinThisPeriodOrNot(row.valid_from, row.valid_until);

    return (
      <React.Fragment>
        <TableRow className={isNthOfTypeOdd ? classes.nthOfTypeOddRow : null}>
          <TableCell style={isInPeriod ? {color: "inherit"} : {color: "#c0c0c0"}}>{row.content}</TableCell>
          <TableCell className={classes.linkCol}>
            {row.url && (
              <HtmlTooltip
                className={classes.htmlToolTip}
                title={<a href={row.url} target="_blank">{row.url}</a>}
                interactive
              >
                <IconButton
                  color="primary"
                  aria-label="add a Link"
                  style={isInPeriod ? {color: "inherit"} : {color: "#c0c0c0"}}
                >
                  <Link />
                </IconButton>
              </HtmlTooltip>
            )}
          </TableCell>
          <TableCell style={isInPeriod ? {color: "inherit"} : {color: "#c0c0c0"}} className={classes.dateCol}>{row.valid_from ? dayjs(row.valid_from).format("YYYY/MM/DD HH:mm:ss") : '-'}</TableCell>
          <TableCell style={isInPeriod ? {color: "inherit"} : {color: "#c0c0c0"}} className={classes.dateCol}>{row.valid_until ? dayjs(row.valid_until).format("YYYY/MM/DD HH:mm:ss") : '-'}</TableCell>
          <TableCell style={isInPeriod ? {color: "inherit"} : {color: "#c0c0c0"}} className={classes.signCol}>{row.display.before_login && "\u2713"}</TableCell>
          <TableCell style={isInPeriod ? {color: "inherit"} : {color: "#c0c0c0"}} className={classes.signCol}>{row.display.after_login && "\u2713"}</TableCell>
          <TableCell className={classes.buttonCol}>
            <IconButton
              color="primary"
              aria-label="add an Edit"
              style={isInPeriod ? {border: "none"} : {color: "#b0c4de"}}
              onClick={() => onClickEditButton(row.id)}
            >
              <Edit />
            </IconButton>
            <IconButton
              className={classes.buttonRed}
              aria-label="add an Delete"
              style={isInPeriod ? {border: "none"} : {color: "#ffb6c1"}}
              onClick={() => openDialog(row.id, row.deleted_at)}
            >
              <Delete />
            </IconButton>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  return (
    <Layout
      content={
        <>
          <Grid>
            <Paper elevation={3} className={classes.paper}>
              <Typography variant="h6" color="primary">
                お知らせ一覧
              </Typography>
              <Grid container spacing={1} style={{padding: "10px", paddingBottom: "20px"}}>
                <Grid item xs={3}>
                  <Typography variant="subtitle2" className={classes.subtitle}>
                    <div>※「リ」= リンク</div>
                    <div>※「ロ」= ログイン画面表示</div>
                    <div>※「ヘ」= ヘッダ通知表示</div>
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Typography variant="subtitle2">
                    <div>アイコンにマウスカーソルをあわせると設定 URL を確認することができます</div>
                    <div>チェックが入っているお知らせがログイン画面に表示されます</div>
                    <div>チェックが入っているとヘッダの「お知らせがあります」内の一覧に載ります</div>
                  </Typography>
                </Grid>
              </Grid>
              <Table className={classes.table} data-testid="informationList-table">
                <TableHead>
                  <TableRow>
                    <TableCell>お知らせ</TableCell>
                    <TableCell>リ</TableCell>
                    <TableCell>掲載開始日時</TableCell>
                    <TableCell>掲載終了日時</TableCell>
                    <TableCell>ロ</TableCell>
                    <TableCell>ヘ</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {informations.map(
                    function (row, index) {
                      return <Row index={index+1} row={row} />
                    }
                  )}
                </TableBody>
              </Table>
            </Paper>
            {success && (
              <MuiAlert
                elevation={6}
                variant="filled"
                severity="success"
                className={classes.alert}
              >
                {successMessage}
              </MuiAlert>
            )}
            <Grid container justifyContent="center" className={classes.wrapper}>
              <Button
                variant="contained"
                color="primary"
                data-testid="informationList-createButton"
                onClick={() => props.history.push(`/admin/information/create`)}
              >
                新規お知らせ登録
              </Button>
            </Grid>
          </Grid>
          <Dialog open={isShowModal} onClose={() => setIsShowModal(false)} data-testid="informationList-deleteDialog">
            <DialogContent>
              <DialogContentText>
                本当に削除してよろしいですか？
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button color="primary" data-testid="informationList-deleteConfirmButton" onClick={() => deleteInformation()}>
                はい
              </Button>
              <Button color="primary" data-testid="informationList-deleteCancelButton" onClick={() => setIsShowModal(false)}>
                いいえ
              </Button>
            </DialogActions>
          </Dialog>
        </>
      }
    />
  );
}

export default withRouter(Information);
